export default __webpack_public_path__ + "static/media/circleRight.e76afa00.png";